import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSession } from '../auth/SessionProvider';
import { buildLoginUrl } from '../auth/swa-auth';
import { Layout } from '../components/Layout';

/**
 * Public login page.
 *
 * No registration, no password field, no local accounts - the only way in is
 * the Microsoft Entra ID sign-in of the OSCOM tenant.
 */
export function LoginPage(): ReactNode {
  const { session } = useSession();

  if (session?.status === 'authenticated') {
    return <Navigate to="/" replace />;
  }

  return (
    <Layout>
      <div className="card card--login">
        <h1>Technische Dokumentationsplattform</h1>
        <p>
          Interne Plattform zur Erstellung und Pflege technischer Kundendokumentationen. Der Zugang
          ist ausschliesslich Mitarbeitenden mit einem Microsoft-Konto der Organisation vorbehalten.
        </p>
        <a className="button button--primary" href={buildLoginUrl('/')}>
          Mit Microsoft anmelden
        </a>
        <p className="muted small">
          Es gibt keine Selbstregistrierung und keine lokalen Passwoerter. Zugriff wird durch die
          IT-Administration vergeben.
        </p>
        {session?.status === 'error' ? (
          <p className="notice notice--warning">{session.message}</p>
        ) : null}
      </div>
    </Layout>
  );
}
